<template>
  <v-container fluid class="py-6">
    <v-alert v-if="error" type="error" dismissible>
      {{ error }}
    </v-alert>
    <v-row>
      <v-col lg="12">
        <v-card class="card-shadow px-4 py-4 overflow-hidden border-radius-xl">
          <v-row>
            <v-col cols="auto">
              <v-avatar width="74" height="74" class="shadow border-radius-lg">
                <img
                  src="@/assets/img/marie.jpg"
                  alt="Avatar"
                  class="border-radius-lg"
                />
              </v-avatar>
            </v-col>
            <v-col cols="auto" class="my-auto">
              <div class="h-100">
                <h5 class="mb-1 text-h5 text-typo font-weight-bold">
                  {{ profileData.name }}
                </h5>
                <p class="mb-0 font-weight-bold text-body text-sm">
                  {{ profileData.job_title }} - {{ profileData.department }}
                </p>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="my-auto">
              <v-btn
                @click="exportDialog = true"
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-info
                  bg-gradient-info
                  py-3
                  px-6
                  mr-3
                "
              >
                <v-icon size="18" class="mr-2">mdi-download</v-icon>
                匯出統計表
              </v-btn>
              <v-btn
                v-if="resolvedUserId"
                @click="goBack"
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-primary
                  bg-gradient-default
                  py-3
                  px-6
                "
              >
                <v-icon size="18">mdi-arrow-left</v-icon>
                返回
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-row>
          <v-col>
            <v-tabs
              background-color="transparent"
              class="text-left"
              v-model="tab"
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab :ripple="false" href="#tab-1">
                <span class="ms-1">基本資料</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-3">
                <span class="ms-1">出勤</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-4">
                <span class="ms-1">變更密碼</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-5">
                <span class="ms-1">特休假</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-9">
                <span class="ms-1">個人假期</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-6">
                <span class="ms-1">請假紀錄</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-7">
                <span class="ms-1">加班紀錄</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-8">
                <span class="ms-1">補休紀錄</span>
              </v-tab>
              <v-tab :ripple="false" href="#tab-2">
                <span class="ms-1">本月排班</span>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <basic-info-widget
              :userData="profileData"
              :profile-data="profileData.employeeProfile"
              @save="savePartial"
              @show-history="showHistory"
            ></basic-info-widget>
            <employment-info-widget
              :profile-data="profileData.employeeProfile"
              @save="savePartial"
              @show-history="showHistory"
            ></employment-info-widget>
            <salary-info-widget
              :profile-data="profileData.employeeProfile"
              @save="savePartial"
              @show-history="showHistory"
            ></salary-info-widget>
          </v-tab-item>

          <v-tab-item value="tab-3">
            <monthly-clock-records
              v-if="resolvedUserId"
              :target-user-id="resolvedUserId"
              :hide-user-select="true"
              :hide-title="true"
            />
          </v-tab-item>

          <v-tab-item value="tab-4">
            <change-password-widget
              :user-id="resolvedUserId"
            ></change-password-widget>
          </v-tab-item>

          <v-tab-item value="tab-5">
            <annual-leave-pagination-widget
              ref="annualLeavePaginationWidget"
              v-if="resolvedUserId"
              :selected-company="selectedCompany"
              :target-user-id="resolvedUserId"
            ></annual-leave-pagination-widget>
          </v-tab-item>

          <v-tab-item value="tab-9">
            <personal-holiday-widget
              ref="personalHolidayWidget"
              v-if="resolvedUserId"
              :target-user-id="resolvedUserId"
            />
          </v-tab-item>

          <v-tab-item value="tab-6">
            <employee-leave-history-widget
              ref="employeeLeaveHistoryWidget"
              v-if="resolvedUserId"
              :selected-company="selectedCompany"
              :target-user-id="resolvedUserId"
            ></employee-leave-history-widget>
          </v-tab-item>

          <v-tab-item value="tab-7">
            <overtime-records-widget
              ref="overtimeRecordsWidget"
              v-if="resolvedUserId"
              :selected-company="selectedCompany"
              :target-user-id="resolvedUserId"
            ></overtime-records-widget>
          </v-tab-item>

          <v-tab-item value="tab-8">
            <compensatory-leaves-widget
              ref="compensatoryLeavesWidget"
              v-if="resolvedUserId"
              :selected-company="selectedCompany"
              :target-user-id="resolvedUserId"
            ></compensatory-leaves-widget>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <v-card class="pa-6" outlined>
              <div v-if="scheduleLoading" class="text-center py-8">
                <v-progress-circular indeterminate color="primary" />
              </div>
              <v-alert
                v-else-if="scheduleError"
                type="warning"
                text
                dense
                class="mb-4"
              >
                {{ scheduleError }}
              </v-alert>

              <!-- 固定工作日：顯示固定班表資訊 -->
              <div v-else-if="scheduleFixedWorkingSetting" class="mt-4">
                <h5 class="text-subtitle-1 font-weight-bold mb-3">
                  固定工作日設定
                </h5>
                <v-simple-table dense class="mb-2">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="text-left">休息日 (recess_day)</th>
                        <td>
                          {{ scheduleFixedWorkingSetting.recess_day || "-" }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left">例假日 (regular_day)</th>
                        <td>
                          {{ scheduleFixedWorkingSetting.regular_day || "-" }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left">上班時間</th>
                        <td>
                          {{ scheduleFixedWorkingSetting.clock_in_time || "-" }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left">下班時間</th>
                        <td>
                          {{
                            scheduleFixedWorkingSetting.clock_out_time || "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left">午休</th>
                        <td>
                          {{
                            scheduleFixedWorkingSetting.lunch_break_start &&
                            scheduleFixedWorkingSetting.lunch_break_end
                              ? `${scheduleFixedWorkingSetting.lunch_break_start} - ${scheduleFixedWorkingSetting.lunch_break_end}`
                              : "—"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <p class="grey--text text--darken-1 mt-2">
                  此員工為固定工作日設定，不使用月排班明細表。
                </p>
              </div>

              <!-- 一般排班：顯示排班明細與班別設定 -->
              <template v-else>
                <schedule-entry-widget
                  :entries="scheduleEntries"
                  :errors="scheduleErrors"
                  :national-holiday-summaries="scheduleNationalHolidaySummaries"
                  :year="scheduleYear"
                  :month="scheduleMonth"
                  :schedule_type="scheduleType"
                  :shift-types="scheduleShiftTypes"
                  @show-table="tab = 'tab-1'"
                />

                <div v-if="!scheduleLoading && !scheduleError" class="mt-6">
                  <h6 class="text-subtitle-1 font-weight-bold mb-3">
                    班別設定
                  </h6>
                  <v-simple-table dense class="mb-2">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">班別代碼</th>
                          <th class="text-left">名稱</th>
                          <th class="text-left">上班 / 下班</th>
                          <th class="text-left">休息分鐘</th>
                          <th class="text-left">午休</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="shift in scheduleShiftTypes" :key="shift.id">
                          <td>{{ shift.code || "-" }}</td>
                          <td>{{ shift.name || "未命名" }}</td>
                          <td>
                            {{
                              shift.clock_in_time
                                ? `${shift.clock_in_time} - ${shift.clock_out_time}`
                                : "無時間設定"
                            }}
                          </td>
                          <td>{{ shift.break_minutes || "-" }}</td>
                          <td>
                            {{
                              shift.lunch_break_start && shift.lunch_break_end
                                ? `${shift.lunch_break_start} - ${shift.lunch_break_end}`
                                : "—"
                            }}
                          </td>
                        </tr>
                        <tr v-if="scheduleShiftTypes.length === 0">
                          <td colspan="5" class="text-center text--disabled">
                            尚未設定班別
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </template>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <!-- History Dialog -->
    <v-dialog v-model="historyDialog" max-width="800px" scrollable>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ historyDialogTitle }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeHistory">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4" style="height: 600px; overflow-y: auto">
          <div v-if="historyLoading" class="text-center py-4">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-else-if="historyError" class="red--text text-center py-4">
            {{ historyError }}
          </div>
          <div
            v-else-if="!historyRecords.length"
            class="grey--text text-center py-4"
          >
            無修改記錄
          </div>
          <v-timeline v-else dense>
            <v-timeline-item
              v-for="record in historyRecords"
              :key="record.id"
              small
              color="primary"
            >
              <template v-slot:opposite>
                <span class="text-caption">
                  {{ formatDateTime(record.create_time) }}
                </span>
              </template>
              <v-card class="elevation-2">
                <v-card-text>
                  <div class="font-weight-bold mb-2">
                    修改人: {{ record.modifier ? record.modifier.name : "-" }}
                    <span
                      v-if="record.modifier && record.modifier.email"
                      class="text-caption grey--text"
                    >
                      ({{ record.modifier.email }})
                    </span>
                  </div>
                  <div class="text-caption grey--text mb-2">
                    {{ formatDateTime(record.create_time) }}
                  </div>
                  <v-divider class="my-2" />
                  <div class="text-body-2">
                    <template v-if="currentHistoryType === 'salary'">
                      <div
                        v-for="field in salaryHistoryFields"
                        :key="field"
                        class="mb-2"
                      >
                        <strong>{{ getFieldLabel(field) }}:</strong>
                        <div class="ml-4">
                          {{ formatFieldValue(field, record[field]) }}
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        v-for="(change, field) in record.changes || {}"
                        :key="field"
                        class="mb-2"
                      >
                        <strong>{{ getFieldLabel(field) }}:</strong>
                        <div class="ml-4">
                          <div class="red--text text--lighten-1">
                            舊值: {{ formatFieldValue(field, change.old) }}
                          </div>
                          <div class="green--text text--darken-1">
                            新值: {{ formatFieldValue(field, change.new) }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
          <div v-if="historyMeta.totalPages > 1" class="text-center mt-4">
            <v-pagination
              v-model="historyPage"
              :length="historyMeta.totalPages"
              @input="loadHistory"
              circle
              color="primary"
            />
          </div>
        </v-card-text>
        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="closeHistory"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            >關閉</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Export Dialog -->
    <v-dialog v-model="exportDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          匯出統計表
          <v-spacer></v-spacer>
          <v-btn icon @click="exportDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="exportRangeType"
                :items="exportRangeOptions"
                label="匯出區間"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="exportYear"
                :items="exportYearOptions"
                label="年份"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="exportMonth"
                :items="exportMonthOptions"
                :label="exportMonthLabel"
                outlined
                dense
                :disabled="exportRangeType === 'year'"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            text
            @click="exportDialog = false"
            class="font-weight-bold text-capitalize"
            >取消</v-btn
          >
          <v-btn
            @click="exportSummaryStats"
            :loading="exporting"
            elevation="0"
            color="primary"
            class="
              font-weight-bold
              text-capitalize
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            >匯出</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { formatDateTime as formatDateTimeUtil } from "@/utils/time";
import BasicInfoWidget from "./Widgets/ProfileWidgets/BasicInfoWidget.vue";
import EmploymentInfoWidget from "./Widgets/ProfileWidgets/EmploymentInfoWidget.vue";
import SalaryInfoWidget from "./Widgets/ProfileWidgets/SalaryInfoWidget.vue";
import ChangePasswordWidget from "./Widgets/ProfileWidgets/ChangePasswordWidget.vue";
import ScheduleEntryWidget from "../Companies/Widgets/ProfileWidgets/ScheduleEntryWidget.vue";
import MonthlyClockRecords from "@/views/Pages/MonthlyClockRecords.vue";
import AnnualLeavePaginationWidget from "@/components/Widgets/AnnualLeavePaginationWidget.vue";
import PersonalHolidayWidget from "@/components/Widgets/PersonalHolidayWidget.vue";
import EmployeeLeaveHistoryWidget from "@/components/Widgets/EmployeeLeaveHistoryWidget.vue";
import OvertimeRecordsWidget from "@/components/Widgets/OvertimeRecordsWidget.vue";
import CompensatoryLeavesWidget from "@/components/Widgets/CompensatoryLeavesWidget.vue";
import { mapGetters } from "vuex";

const SALARY_HISTORY_FIELDS = [
  "basic_salary",
  "extra_salary",
  "supervisor_allowance",
  "position_allowance",
  "food_allowance",
  "company_extra_salary",
  "employee_welfare_fund",
  "bonus",
  "employee_voluntary_pension",
  "employee_voluntary_pension_rate",
  "dependent_insured_count",
  "insurance_bracket_max",
  "extra_insurance",
];

export default {
  name: "UserProfile",
  components: {
    BasicInfoWidget,
    EmploymentInfoWidget,
    SalaryInfoWidget,
    ChangePasswordWidget,
    ScheduleEntryWidget,
    MonthlyClockRecords,
    AnnualLeavePaginationWidget,
    PersonalHolidayWidget,
    EmployeeLeaveHistoryWidget,
    OvertimeRecordsWidget,
    CompensatoryLeavesWidget,
  },
  props: {
    userId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      tab: "tab-1",
      profileData: {},
      loading: false,
      error: null,
      resolvedUserId:
        this.userId ??
        (this.$route && this.$route.params && this.$route.params.id
          ? Number(this.$route.params.id)
          : null),
      historyDialog: false,
      historyLoading: false,
      historyRecords: [],
      historyMeta: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
      },
      currentHistoryType: "profile",
      historyPage: 1,
      historyError: null,
      scheduleLoading: false,
      scheduleError: null,
      scheduleYear: new Date().getFullYear(),
      scheduleMonth: new Date().getMonth() + 1,
      scheduleEntries: [],
      scheduleErrors: [],
      scheduleNationalHolidaySummaries: [],
      scheduleType: "",
      scheduleShiftTypes: [],
      scheduleFixedWorkingSetting: null,
      scheduleLoaded: false,
      exportDialog: false,
      exporting: false,
      exportRangeType: "month",
      exportRangeOptions: [
        { text: "月", value: "month" },
        { text: "季", value: "quarter" },
        { text: "半年", value: "half_year" },
        { text: "年度", value: "year" },
      ],
      exportYear: new Date().getFullYear(),
      exportMonth: new Date().getMonth() + 1,
    };
  },
  computed: {
    ...mapGetters("company", ["companies", "selectedCompany"]),
    historyDialogTitle() {
      return this.currentHistoryType === "salary" ? "薪資修改記錄" : "修改記錄";
    },
    salaryHistoryFields() {
      return SALARY_HISTORY_FIELDS;
    },
    exportYearOptions() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 5 }, (_, i) => currentYear - i);
    },
    exportMonthOptions() {
      if (this.exportRangeType === "quarter") {
        return [
          { text: "第1季", value: 1 },
          { text: "第2季", value: 4 },
          { text: "第3季", value: 7 },
          { text: "第4季", value: 10 },
        ];
      } else if (this.exportRangeType === "half_year") {
        return [
          { text: "上半年", value: 1 },
          { text: "下半年", value: 7 },
        ];
      }
      return Array.from({ length: 12 }, (_, i) => ({
        text: `${i + 1}月`,
        value: i + 1,
      }));
    },
    exportMonthLabel() {
      if (this.exportRangeType === "quarter") return "季別";
      if (this.exportRangeType === "half_year") return "半年度";
      return "月份";
    },
  },
  created() {
    // Get user ID from route params
    this.fetchUserProfile();
    window.scrollTo(0, 0);
  },
  watch: {
    tab(val) {
      this.$nextTick(() => {
        if (val === "tab-5") {
          this.$refs.annualLeavePaginationWidget?.fetchAnnualLeaves();
        } else if (val === "tab-9") {
          this.$refs.personalHolidayWidget?.fetchHolidays?.();
        } else if (val === "tab-6") {
          if (this.$refs.employeeLeaveHistoryWidget) {
            this.$refs.employeeLeaveHistoryWidget.fetchRecords();
          }
        } else if (val === "tab-7") {
          this.$refs.overtimeRecordsWidget?.fetchOvertimeRecords();
        } else if (val === "tab-8") {
          this.$refs.compensatoryLeavesWidget?.fetchCompensatoryLeaves();
        } else if (val === "tab-2") {
          this.fetchEmployeeSchedule();
        }
      });
    },
    exportRangeType(val) {
      if (val === "quarter") {
        this.exportMonth = 1;
      } else if (val === "half_year") {
        this.exportMonth = 1;
      } else {
        this.exportMonth = new Date().getMonth() + 1;
      }
    },
  },
  methods: {
    async savePartial(payload, done) {
      this.error = null;
      try {
        await this.$axios.put(`/api/users/${this.resolvedUserId}`, payload);
        await this.fetchUserProfile();
        if (typeof done === "function") done(true);
      } catch (err) {
        console.error("Error saving partial profile:", err);
        const apiMessage = err?.response?.data?.message;
        this.error = apiMessage || "Failed to save user profile data";
        if (typeof done === "function") done(false, err);
      }
    },
    async exportSummaryStats() {
      const companyId =
        this.profileData?.company_id ||
        this.selectedCompany?.id ||
        this.selectedCompany?.company_id;
      if (!companyId) {
        this.error = "找不到公司資訊，無法匯出";
        return;
      }
      this.exporting = true;
      try {
        const params = {
          company_id: companyId,
          user_id: this.resolvedUserId,
          year: this.exportYear,
          rangeType: this.exportRangeType,
        };
        if (this.exportRangeType !== "year") {
          params.month = this.exportMonth;
        }

        const response = await this.$axios.get(
          "/api/summary/monthly-summary-statistics/export",
          {
            params,
            responseType: "blob",
          },
        );

        const contentDisposition = response.headers["content-disposition"];
        let filename = `statistic-${this.exportRangeType}-${this.exportYear}-user-${this.resolvedUserId}.xlsx`;
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);
          if (filenameMatch && filenameMatch.length === 2) {
            filename = filenameMatch[1];
          }
        }

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        this.exportDialog = false;
      } catch (err) {
        console.error("Error exporting summary stats:", err);
        this.error = "匯出失敗，請稍後再試";
      } finally {
        this.exporting = false;
      }
    },
    transformScheduleEntries(entries) {
      if (!entries || !Array.isArray(entries)) return [];
      return entries.map((entry) => {
        const days = {};
        for (let d = 1; d <= 31; d += 1) {
          days[d] = {
            status: entry[`day${d}_status`] ?? null,
            shift_type_id: entry[`day${d}_shift_type_id`] ?? null,
            clock: entry[`day${d}_clock`] ?? null,
          };
        }
        return {
          ...entry,
          employee: {
            user_id: entry.user?.id ?? entry.user_id,
            emp_id: entry.user?.member_id ?? "",
            name: entry.user?.name ?? "",
          },
          days,
          schedule_type: entry.schedule_type || "",
        };
      });
    },
    async fetchUserProfile() {
      this.loading = true;
      this.error = null;

      try {
        let response;
        if (
          this.resolvedUserId === null ||
          this.resolvedUserId === "" ||
          this.resolvedUserId === undefined
        ) {
          response = await this.$axios.get(`/api/users/my`);
          this.resolvedUserId = response.data.id;
        } else {
          response = await this.$axios.get(`/api/users/${this.resolvedUserId}`);
        }

        this.profileData = response.data;
        this.scheduleLoaded = false;
      } catch (err) {
        console.error("Error fetching user profile:", err);
        this.error = "Failed to load user profile data";
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      // If parent listens, let it handle; otherwise fallback to router navigation
      if (this.$listeners && this.$listeners.back) {
        this.$emit("back");
        return;
      }
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: "UserManagement" });
      }
    },
    async showHistory(historyType = "profile") {
      this.currentHistoryType = historyType;
      this.historyPage = 1;
      this.historyDialog = true;
      await this.loadHistory();
    },
    async loadHistory() {
      if (
        !this.profileData ||
        !this.profileData.employeeProfile ||
        !this.profileData.employeeProfile.id
      )
        return;

      this.historyLoading = true;
      this.historyError = null;

      try {
        const queryParams = new URLSearchParams({
          page: this.historyPage,
          limit: this.historyMeta.limit,
        });

        const historyPath =
          this.currentHistoryType === "salary"
            ? `/api/history/employee-salaries/${this.profileData.employeeProfile.id}`
            : `/api/history/employee-profiles/${this.profileData.employeeProfile.id}`;

        const response = await this.$axios.get(`${historyPath}?${queryParams}`);

        this.historyRecords = response.data.data || [];
        this.historyMeta = response.data.meta || {
          page: 1,
          limit: 10,
          total: 0,
          totalPages: 0,
        };
      } catch (error) {
        this.historyError =
          error?.response?.data?.message || error.message || "無法載入歷史記錄";
        this.historyRecords = [];
      } finally {
        this.historyLoading = false;
      }
    },
    closeHistory() {
      this.historyDialog = false;
      this.historyRecords = [];
      this.historyError = null;
      this.historyPage = 1;
      this.currentHistoryType = "profile";
    },
    async fetchEmployeeSchedule() {
      if (!this.resolvedUserId) return;
      // console.log("fetching employee schedule", this.resolvedUserId);
      const companyId =
        this.profileData?.company_id ||
        this.selectedCompany?.id ||
        this.selectedCompany?.company_id;
      if (!companyId) {
        this.scheduleError = "找不到公司資訊，無法載入排班";
        this.scheduleEntries = [];
        this.scheduleErrors = [];
        this.scheduleNationalHolidaySummaries = [];
        this.scheduleType = "";
        this.scheduleShiftTypes = [];
        this.scheduleFixedWorkingSetting = null;
        return;
      }

      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      this.scheduleLoading = true;
      this.scheduleError = null;

      try {
        const scheduleRes = await this.$axios.get("/api/scheduling/entries", {
          params: {
            company_id: companyId,
            year,
            month,
            user_id: this.resolvedUserId,
          },
        });

        this.scheduleYear = year;
        this.scheduleMonth = month;
        this.scheduleFixedWorkingSetting =
          scheduleRes.data.fixedWorkingSetting || null;
        this.scheduleEntries = this.scheduleFixedWorkingSetting
          ? []
          : this.transformScheduleEntries(scheduleRes.data.data || []);
        this.scheduleErrors = [];
        this.scheduleNationalHolidaySummaries =
          scheduleRes.data.nationalHolidaySummaries || [];
        const firstType = this.scheduleEntries[0]?.schedule_type || "";
        this.scheduleType = this.formatScheduleType(firstType);
        this.scheduleShiftTypes = scheduleRes.data.shiftTypes || [];
        this.scheduleLoaded = true;
      } catch (error) {
        if (error?.response?.status === 404) {
          this.scheduleYear = year;
          this.scheduleMonth = month;
          this.scheduleEntries = [];
          this.scheduleErrors = [];
          this.scheduleNationalHolidaySummaries = [];
          this.scheduleType = "";
          this.scheduleShiftTypes = [];
          this.scheduleFixedWorkingSetting = null;
          this.scheduleError = `${year}年${String(month).padStart(
            2,
            "0",
          )}月找不到對應的班表`;
          this.scheduleLoaded = true;
        } else {
          console.error("Error fetching employee schedule:", error);
          this.scheduleError = "載入排班資料失敗";
          this.scheduleEntries = [];
          this.scheduleErrors = [];
          this.scheduleNationalHolidaySummaries = [];
          this.scheduleType = "";
          this.scheduleShiftTypes = [];
          this.scheduleFixedWorkingSetting = null;
          this.scheduleLoaded = true;
        }
      } finally {
        this.scheduleLoading = false;
      }
    },
    formatDateTime(value) {
      return formatDateTimeUtil(value);
    },
    formatScheduleType(type) {
      const map = {
        GENERAL: "一般",
        BIWEEKLY_FLEX: "雙週變形工時",
        FOURWEEK_FLEX: "四週變形工時",
      };
      return map[type] || type || "";
    },
    getFieldLabel(field) {
      const labels = {
        name: "姓名",
        english_name: "英文姓名",
        member_id: "工號",
        department: "部門",
        store: "店舖",
        job_title: "職位",
        role: "角色",
        mobile_phone: "手機",
        email: "Email",
        contact_person: "聯絡人",
        contact_phone: "聯絡電話",
        contact_relation: "關係",
        gender: "性別",
        birthday: "生日",
        marital_status: "婚姻狀況",
        military_status: "兵役狀況",
        nationality: "國籍",
        highest_education: "最高學歷",
        passport_no: "護照號碼",
        home_phone: "住家電話",
        registered_city: "戶籍市",
        registered_region: "戶籍區",
        registered_address: "戶籍地址",
        mailing_city: "通訊市",
        mailing_region: "通訊區",
        mailing_address: "通訊地址",
        approval_status: "審核狀態",
        supervisor_allowance: "主管加給",
        position_allowance: "職務加給",
        food_allowance: "伙食津貼",
        basic_salary: "底薪",
        extra_salary: "額外薪資",
        employee_welfare_fund: "職工福利金",
        dependent_insured_count: "眷屬加保人數",
        insurance_bracket_max: "勞保級距上限",
        company_extra_salary: "自訂加給",
        extra_insurance: "額外保險",
        employee_voluntary_pension: "勞工自提勞退",
        employee_voluntary_pension_rate: "勞工自提勞退率",
        bonus: "績效獎金",
        contract_type: "合約類型",
        contract_work_type: "工時類型",
        contract_salary_type: "計薪方式",
        salary_pay_freq: "發薪頻率",
        salary_settle_freq: "結算頻率",
      };
      return labels[field] || field;
    },
    formatFieldValue(field, value) {
      if (value === null || value === undefined) {
        return "-";
      }
      if (field === "employee_voluntary_pension") {
        return value ? "是" : "否";
      }
      if (field === "dependent_insured_count") {
        return `${value} 人`;
      }
      if (
        field === "company_extra_salary" ||
        field === "extra_insurance" ||
        typeof value === "object"
      ) {
        try {
          return JSON.stringify(value);
        } catch {
          return String(value);
        }
      }
      return value;
    },
  },
};
</script>
